export const PRODUCT_3D_VIEWER_PATH = '/webapi/viewer-3d';

export const isProduct3dModalEnabled = false;

export const PRODUCT_3D_VIEWER_MESSAGES = {
    COLOR_SELECT: 'viewer-3d:color-select',
    OPEN_MODAL: 'viewer-3d:open-modal',
    READY: 'viewer-3d:ready',
    LOADING: 'viewer-3d:loading',
} as const;
